/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createSurvey = /* GraphQL */ `mutation CreateSurvey(
  $input: CreateSurveyInput!
  $condition: ModelSurveyConditionInput
) {
  createSurvey(input: $input, condition: $condition) {
    termAgreement {
      personalInfo
      service
      __typename
    }
    mainSurveyCode
    mainSymptom
    mode
    surveyType
    patient {
      patientName
      gender
      birth
      __typename
    }
    clinic
    completedDt
    id
    firstLinkClickDt
    visitCount
    rawData
    reviewRating
    reviewComment
    byeonjeungData
    recommendHerbs
    solutionClickCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSurveyMutationVariables,
  APITypes.CreateSurveyMutation
>;
export const updateSurvey = /* GraphQL */ `mutation UpdateSurvey(
  $input: UpdateSurveyInput!
  $condition: ModelSurveyConditionInput
) {
  updateSurvey(input: $input, condition: $condition) {
    termAgreement {
      personalInfo
      service
      __typename
    }
    mainSurveyCode
    mainSymptom
    mode
    surveyType
    patient {
      patientName
      gender
      birth
      __typename
    }
    clinic
    completedDt
    id
    firstLinkClickDt
    visitCount
    rawData
    reviewRating
    reviewComment
    byeonjeungData
    recommendHerbs
    solutionClickCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSurveyMutationVariables,
  APITypes.UpdateSurveyMutation
>;
export const deleteSurvey = /* GraphQL */ `mutation DeleteSurvey(
  $input: DeleteSurveyInput!
  $condition: ModelSurveyConditionInput
) {
  deleteSurvey(input: $input, condition: $condition) {
    termAgreement {
      personalInfo
      service
      __typename
    }
    mainSurveyCode
    mainSymptom
    mode
    surveyType
    patient {
      patientName
      gender
      birth
      __typename
    }
    clinic
    completedDt
    id
    firstLinkClickDt
    visitCount
    rawData
    reviewRating
    reviewComment
    byeonjeungData
    recommendHerbs
    solutionClickCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSurveyMutationVariables,
  APITypes.DeleteSurveyMutation
>;
